module.exports = __webpack_public_path__ + "static/media/curriculum_theme_music.b5ff08d8.svg";